module.exports = __webpack_public_path__ + "img/no-cai-img.f3c039ea.jpg";